export default __webpack_public_path__ + "static/media/Other.23723371.svg";